import React from 'react';
import { TICKET_STATUS } from '../../services/supportService';

const TicketStatusBadge = ({ status }) => {
  const getStatusStyle = () => {
    switch (status) {
      case TICKET_STATUS.NEW:
        return 'bg-info/20 text-info border border-info/30';
      case TICKET_STATUS.IN_PROGRESS:
        return 'bg-warning/20 text-warning border border-warning/30';
      case TICKET_STATUS.RESOLVED:
        return 'bg-success/20 text-success border border-success/30';
      case TICKET_STATUS.CLOSED:
        return 'bg-base-content/20 text-base-content/70 border border-base-content/30';
      default:
        return 'bg-base-200 text-base-content/60 border border-base-200';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case TICKET_STATUS.NEW:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path d="M5.25 12a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM5.25 9a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 015.25 9zM5.25 6a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 015.25 6zM4.25 3a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM3.5 15a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM4.25 9a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM4.25 6a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5z" />
          </svg>
        );
      case TICKET_STATUS.IN_PROGRESS:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z" clipRule="evenodd" />
          </svg>
        );
      case TICKET_STATUS.RESOLVED:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
          </svg>
        );
      case TICKET_STATUS.CLOSED:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-4.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm0-8a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75z" clipRule="evenodd" />
          </svg>
        );
      default:
        return null;
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case TICKET_STATUS.NEW:
        return 'Nouveau';
      case TICKET_STATUS.IN_PROGRESS:
        return 'En cours';
      case TICKET_STATUS.RESOLVED:
        return 'Résolu';
      case TICKET_STATUS.CLOSED:
        return 'Fermé';
      default:
        return status || 'Inconnu';
    }
  };

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusStyle()}`}>
      {getStatusIcon()}
      {getStatusLabel()}
    </span>
  );
};

export default TicketStatusBadge;